import { get, post } from '../httpMethods';
import { ApiResponse, LoginCredentials, LoginResponse } from '../../types/api';

export const authService = {
  login: (credentials: LoginCredentials): Promise<ApiResponse<LoginResponse>> => {
    return post<LoginResponse>('/auth/login', credentials);
  },

  logout: (): Promise<ApiResponse<void>> => {
    return post('/auth/logout');
  },

  refreshToken: (): Promise<ApiResponse<LoginResponse>> => {
    return post<LoginResponse>('/auth/refresh');
  },

  me: (): Promise<ApiResponse<LoginResponse>> => {
    return get<LoginResponse>('/auth/me');
  },

  /** Super admin only: start a session as another user account. */
  impersonate: (userId: string): Promise<ApiResponse<LoginResponse>> => {
    return post<LoginResponse>(`/auth/impersonate/${userId}`);
  },

  /** Return to the original super admin account after switching. */
  stopImpersonation: (): Promise<ApiResponse<LoginResponse>> => {
    return post<LoginResponse>('/auth/impersonate/stop');
  },
};
